import React, { useEffect } from 'react';
import './Intro.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/base16/onedark.css';

const Intro = () => {

	useEffect(() => {
		hljs.highlightAll();
	}, []);
	
const codice1 = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>
<body>
    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
    </br>
    <a href="...">Google</a>
    </br>
    <img src="..."/>
</body>
</html>`;

const codice2 = `//Se da errore sui permessi per eseguire script: https://turbolab.it/windows-10/come-attivare-abilitare-esecuzione-script-.ps-powershell-impossibile-caricare-file.-esecuzione-script-disattivata-sistema-uso-aboutexecutionpolicies-966

//Import del modulo "http"
let http = require("http")

//Import del modulo "fs". Serve per operare sul filesystem
let fs = require("fs")

//Per startare: node nomefile.js. Avviato, il server resta sempre in ascolto. Per aggiornamento automatico: nodemon nomefile.js.
//Per chiudere: CTRL + C
//Creazione del server, con parametri "request" e "response", in ascolto sulla porta 3000
//Request: comunicazione tra CLIENT e SERVER
//Response: comunicazione tra SERVER e CLIENT

http.createServer((req,res)=>{

    //Codice
    res.setHeader('content-type', 'text/html')
    // res.write("<strong>Benvenuto</strong>"); // Appende il testo o l'html all'interno del pacchetto.
    let contenutoFile = fs.readFileSync("./index.html") // Finchè non vengono caricati tutti i dati, l'end non viene richiamato
    res.end(contenutoFile); // Prende il pacchetto e lo invia al client.
    
}).listen("3000")`;

  return (
    <div className="container-fluid d-flex justify-content-center">
    	<div className="div-intro">
			<h1 data-aos="zoom-in">Contenuti</h1>
			<hr className="underline" data-aos="zoom-in"/>
			<br/>
			<ol data-aos="zoom-in">
				<li><a href="#introduzione">Introduzione</a></li>
				<li><a href="#parametri">Passaggio di parametri</a></li>
				<li><a href="#dispatcher">Dispatcher</a></li>
				<li><a href="#moduli">I moduli</a>
					<ol>
						<li><a href="#commonjs">CommonJS</a></li>
						<li><a href="#esmodules">ES modules</a></li>
					</ol>
				</li>
				<li><a href="#async">Async</a></li>
				<li><a href="#express">Express</a></li>
				<li><a href="#template-engine">Template Engine</a>
					<ol>
						<li><a href="#ejs">EJS</a></li>
					</ol>
				</li>
			</ol>
		</div>
    </div>
  );
};

export default Intro;
